const getDayName = (weekday) => {
  return {
    0: 'Domingo',
    1: 'Segunda',
    2: 'Terça',
    3: 'Quarta',
    4: 'Quinta',
    5: 'Sexta',
    6: 'Sábado'
  }[weekday] || '';
};

/**
 * Formata a data para o modelo especificado
 *
 * @function
 * @param {string} date
 * @param {string} format
 * @return {string}
 */
export default (date, format) => {
  const d = typeof date === 'string' ? new Date(date.replace(' ', 'T')) : new Date(date);

  let res = format + '';
  res = res.replace('DD', ('' + d.getDate()).padStart(2, '0'));
  res = res.replace('MM', ('' + (d.getMonth() + 1)).padStart(2, '0'));
  res = res.replace('hh', ('' + d.getHours()).padStart(2, '0'));
  res = res.replace('HH', ('' + d.getHours()).padStart(2, '0'));
  res = res.replace('mm', ('' + d.getMinutes()).padStart(2, '0'));
  res = res.replace('ss', ('' + d.getSeconds()).padStart(2, '0'));
  res = res.replace('YYYY', d.getFullYear());
  res = res.replace('dddd', getDayName(d.getDay()))

  return res;
};
